<template>
  <v-card flat tile class="overflow-y-auto">
    <v-window v-model="step">
      <template v-for="(section, sectionIndex) in sectionList">
        <v-window-item
          :value="sectionIndex"
          :key="sectionIndex"
          class="pa-0 ma-0"
        >
          <div class="section-panel">
            <div class="section-header">
              <h2 class="pl-4 pb-2 pt-2">
                <a-chip
                  small
                  class="mb-1"
                  color="Neutral"
                  style="border: 1px solid var(--v-secondary-base) !important"
                >
                  {{ $t("poll.lblSection") }} {{ sectionIndex + 1 }}
                </a-chip>
                <span class="white--text ml-2">{{ section.title }}</span>
              </h2>
            </div>
            <div class="ma-4" v-html="$sanitizeHtml(section.description)"></div>
          </div>

          <template v-for="(question, index) in section.questions">
            <div :key="`question-${question.id}`">
              <v-row class="mb-4 mt-4" no-gutters>
                <v-col
                  md="11"
                  class="pl-4 text-h6 font-weight-regular"
                  >
                  {{ section.prevQuestionCount + index + 1 }}.
                  <span v-html="questionText(question.question)" ></span>
                  <v-tooltip top v-if="question.isMandatory">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs"
                v-on="on" v-if="question.isMandatory" style="color: red" class="ml-1">
                  *
                </span>
              </template>
              <span>{{ $t("poll.ruleRequired") }} </span>
            </v-tooltip>
                </v-col>
                <v-col
                    v-if="tab === 'response'"
                    md="1"
                    class="text-center"
                  >
                  <v-btn
                    icon
                      color="grey"
                      small
                      depressed
                      @click="toggleExpand(question.id)"
                      >
                      <v-icon>
                        {{ expandedIds.includes(question.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                    </v-btn>
                  </v-col>
              </v-row>
              <v-card-subtitle
                class="ml-5 pt-5 pb-0"
                v-if="question.isSubtitle"
                >
                <span v-html="questionText(question.subtitle)" ></span>
                </v-card-subtitle>
              <transition
                name="slide"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
              >
              <v-card-text  v-if="!expandedIds.includes(question.id)">
                <v-form
                  ref="refSurveyQuestionForm"
                  v-model="valid"
                  lazy-validation
                  :section="sectionIndex"
                >
                  <text-type-choice
                    v-if="question.type === 'textType'"
                    :question="question"
                    :isReadOnly="isReadOnly"
                  ></text-type-choice>
                  <likert-type
                    v-else-if="question.type === 'likert'"
                    :question="question"
                    :isReadOnly="isReadOnly"
                  ></likert-type>
                  <rating-type
                    v-else-if="question.type === 'rating'"
                    :question="question"
                    :isReadOnly="isReadOnly"
                  ></rating-type>
                  <v-list v-else>
                    <v-input
                      :value="question.selectedAnswer"
                      :rules="question.isMandatory ? [requiredRules] : []"
                    >
                      <v-list-item-group
                        :multiple="question.isMultipleAnswer"
                        color="indigo"
                        :key="index"
                        v-model="question.selectedAnswer"
                        :id="`lis_group_${question.id}`"
                        style="width: 100%"
                      >
                        <check-box-choice
                          v-if="question.isMultipleAnswer"
                          :question="question"
                          :isReadOnly="isReadOnly"
                        >
                        </check-box-choice>
                        <radio-button-choice
                          v-else
                          :question="question"
                          :isReadOnly="isReadOnly"
                        ></radio-button-choice>
                      </v-list-item-group>
                    </v-input>
                  </v-list>
                </v-form>
              </v-card-text>
            </transition>
              <v-divider class="mx-4"></v-divider>
            </div>
          </template>
        </v-window-item>
      </template>
    </v-window>
    <v-divider></v-divider>
    <v-card-actions>
      <v-tooltip top v-model="backTooltip">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            class="ma-3"
            small
            rounded
            color="primaryDark"
            :disabled="step === 0"
            @click="back"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t("Back") }}
          </a-btn>
        </template>
        <span>{{ $t("Back") }} </span>
      </v-tooltip>

      <div style="width: 300px">
        <v-progress-linear
          :value="((step + 1) / sections.length) * 100"
          height="28"
          color="primaryDark"
          dark
          rounded
        >
          <strong>{{ step + 1 }}/{{ sections.length }}</strong>
        </v-progress-linear>
      </div>
      <v-tooltip top v-model="nextTooltip">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            class="ma-3"
            rounded
            :disabled="step === sections.length - 1"
            small
            color="primaryDark"
            depressed
            @click="next"
            v-bind="attrs"
            v-on="on"
          >
            {{ $t("Next") }}
          </a-btn>
        </template>
        <span>{{ $t("Next") }} </span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-if="!isReadOnly"
            @click="onSaveDraftSurvey"
            color="primaryDark"
            class="ma-3"
            small
            v-bind="attrs"
            v-on="on"
          >
            {{ $t("poll.btnSaveDraft") }}
          </a-btn>
        </template>
        <span>{{ $t("poll.btnSaveDraft") }} </span>
      </v-tooltip>
      <!-- <v-btn
        shaped
        class="ma-3"
        color="pageHeader"
        small
        dark
        v-if="!isReadOnly"
        @click="onSaveDraftSurvey"
        >{{ $t("poll.btnSaveDraft") }}
      </v-btn> -->
      <span v-if="step === sections.length - 1">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-if="!isReadOnly"
              class="ma-3"
              @click="onSubmitSurvey(false)"
              color="primaryDark"
              small
              v-bind="attrs"
              v-on="on"
            >
              {{ $t("poll.btnSubmit") }}</a-btn
            >
          </template>
          <span>{{ $t("poll.btnSubmit") }} </span>
        </v-tooltip>
        <!-- <v-btn
          shaped
          class="ma-3"
          color="pageHeader"
          small
          dark
          v-if="!isReadOnly"
          @click="onSubmitSurvey(false)"
          >{{ $t("poll.btnSubmit") }}
        </v-btn> -->
      </span>
    </v-card-actions>
    <ConfirmDialog ref="confirm" />
    <message-sheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></message-sheet>
  </v-card>
</template>

<script>
import CheckBoxChoice from "./CheckBoxChoice.vue";
import RadioButtonChoice from "./RadioButtonChoice.vue";
import _ from "lodash";
import { mapActions } from "vuex";
import { createUUID } from "../../utils/util";
import TextTypeChoice from "./components/TextTypeChoice.vue";
import MessageSheet from "../MessageSheet.vue";
import RatingType from "./components/RatingType.vue";
import LikertType from "./components/LikertType.vue";
import Loader from "@/components/Loader";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import Vue from "vue";
import {
  RichTextEditorPlugin,
  HtmlEditor,
} from "@syncfusion/ej2-vue-richtexteditor";
import { colGroupRefresh } from "@syncfusion/ej2-grids";
Vue.use(RichTextEditorPlugin);

export default {
  components: {
    CheckBoxChoice,
    RadioButtonChoice,
    TextTypeChoice,
    MessageSheet,
    RatingType,
    LikertType,
    Loader,
    ConfirmDialog,
  },
  name: "SurveyQuestions",
  provide: {
    richtexteditor: [HtmlEditor],
  },
  props: {
    surveyQuestions: {
      type: [Object, Array],
    },
    answer: {
      type: [Number, String, Array, Object],
    },

    isReadOnly: { type: Boolean, default: false },
    tab: {
      type: String,
      default: 'question',
    },
  },

  computed: {
    LoaderText() {
      return this.$t("LoaderText");
    },
    nextTooltip: {
      get() {
        return (
          this.step === this.sections.length - 1 && this.sections.length > 1
        );
      },
      set(value) {
        return value;
      },
    },
    backTooltip: {
      get() {
        return (
          this.step === 0 &&
          this.sectionFirstLoader !== false &&
          this.sections.length > 1
        );
      },
      set(value) {
        return value;
      },
    },
    questionsDetails() {
      let questions = this.surveyQuestions
        ? this.surveyQuestions.questions
        : [];
      return questions;
    },
    sections() {
      return this.surveyQuestions ? this.surveyQuestions.sections : [];
    },
    sectionList() {
      //return this.surveyQuestions ? this.surveyQuestions.sections.map(obj=>({ ...obj, questions:this.getQuestionsForSection(obj.sectionId)})):[];
      let index = 0;
      let res = [];
      this.sections.forEach((s) => {
        let questions = this.getQuestionsForSection(s.sectionId);
        res.push({
          ...s,
          questions: questions,
          prevQuestionCount: index,
        });
        index = index + questions.length;
      });
      return res;
    },
    commentModel() {
      return {
        type: "Expand",
        enable: false,
      };
    },
  },
  data() {
    return {
      displayMessage: false,
      messageType: "",
      message: "",
      valid: true,
      step: 0,
      sectionFirstLoader: false,
      expandedIds: []
    };
  },
  methods: {
    back() {
      this.step--;
      window.scrollTo(0, 0);
    },
    next() {
      let isFormValid = true;
      this.$refs.refSurveyQuestionForm.forEach(async (form) => {
        if (!form.validate() && form.$attrs.section == this.step) {
          isFormValid = false;
        }
      });
      if (isFormValid) {
        this.step++;
        window.scrollTo(0, 0);
        this.sectionFirstLoader = true;
      }
    },
    getQuestionsForSection(sectionid) {
      let questions = this.questionsDetails.filter(
        (f) => f.sectionId === sectionid
      );
      return questions;
    },

    ...mapActions({
      submitSurveyResult: "poll/submitSurveyResult",
    }),
    onSubmitSurvey,
    onSaveDraftSurvey,
    createUUID,
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    requiredRules(value) {
      return (!!value && value.length > 0) || this.$t("poll.ruleSelectOneItem");
    },
    questionText(html){
      const htmlContent = html.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
      const content = htmlContent ? htmlContent.replace(/\n/g, '<br>') : ''
      return this.$sanitizeHtml(content)
    },
    toggleExpand(id) {
      const index = this.expandedIds.indexOf(id);
      if (index === -1) {
        // Add the ID if not present
        this.expandedIds.push(id);
      } else {
        // Remove the ID if already present
        this.expandedIds.splice(index, 1);
      }
    },
    beforeEnter(el) {
      el.style.height = '0';
      el.style.opacity = '0';
    },
    enter(el, done) {
      const height = el.scrollHeight;
      el.style.height = `${height}px`;
      el.style.opacity = '1';
      el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      setTimeout(() => {
        el.style.height = 'auto';
        done();
      }, 300);
    },
    leave(el, done) {
      el.style.height = `${el.scrollHeight}px`;
      el.style.opacity = '1';
      setTimeout(() => {
        el.style.height = '0';
        el.style.opacity = '0';
        el.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        done();
      }, 0);
    }
  },
};
async function onSaveDraftSurvey() {
  if (this.surveyQuestions.user_responded === true) {
    if (
      await this.$refs.confirm.open(
        this.$t("poll.hConfirmSaveDraftHeading"),
        this.$t("poll.msgConfirmSaveDraft"),
        { yesNoButtons: true }
      )
    ) {
      this.onSubmitSurvey(true);
    }
  } else {
    this.onSubmitSurvey(true);
  }
}
async function onSubmitSurvey(isDraft) {
  try {
    let isFormValid = true;
    if (isDraft !== true) {
      this.$refs.refSurveyQuestionForm.forEach(async (form) => {
        if (!form.validate()) {
          isFormValid = false;
        }
      });
    }
    if (isFormValid) {
      const answer = _.cloneDeep(
        this.surveyQuestions.questions.map((x) => {
          return {
            answer: x.selectedAnswer,
            questionId: x.id,
            type: x.type,
            isMultipleAnswer: x.isMultipleAnswer,
          };
        })
      );
      let emailMessage = `<p><b>${this.$t("poll.surveySubmitEmailContent")}: </b> <br/> <br/></p>`;
      emailMessage += `<b>${this.$t("poll.lblSurveyTitle")}: </b> ${this.surveyQuestions.title} <br/>`;
      emailMessage += `<b>${this.$t("poll.lblRespondent")}: </b> ${this.$auth.user.name} <br/>`;
      emailMessage += `<b>${this.$t("agenda.lblEmailAddress")}: </b> ${this.$auth.user.email} <br/>`;
      const emailTemplateData = {
            template_id: process.env.VUE_APP_REMIND_VOTING_TEMPLATE_ID,
            subject: this.$t("poll.surveyEmailSubject"),
            message: emailMessage,
            tenant: sessionStorage.getItem("tenantId"),
            emailDearRecipient: this.$t("email.emailDearRecipient", {
              username: '{USERNAME}',
            }),
            emailPreHeader: this.$t("email.emailPreHeader"),
            targetTitle: this.surveyQuestions.title,
            targetLinkLabel: this.$t("poll.surveyTargetLinkLabel"),
            targetLink: `${window.location.origin}/survey/${this.surveyQuestions.id}/tenant/${sessionStorage.getItem("tenantId")}/survey`,
        };
      const finalResult = {
        id: createUUID(),
        surveyid: this.surveyQuestions.id,
        userid: this.$auth.user.email,
        userName: this.$auth.user.tenantUserName,
        tenantid: sessionStorage.getItem("tenantId"),
        submitDate: new Date().toISOString(),
        questionAnswers: answer,
        draft: isDraft === true ? true : false,
        email_data: emailTemplateData,
      };
      await this.submitSurveyResult(finalResult);
      if (isDraft !== true) {
        this.surveyQuestions.user_responded = true;
      } else {
        this.surveyQuestions.user_responded = false;
      }
      this.showMessageSheet(
        isDraft === true
          ? this.$t("poll.SurveyDraftSubmitSuccess")
          : this.$t("poll.SurveySubmitSuccess"),
        "success"
      );
    } else {
      this.showMessageSheet(this.$t("poll.msgSurveyIncomplete"), "info");
    }
  } catch (error) {
     console.log(error, "survey question section")
  }
}
</script>

<style scoped>
::v-deep .section-header {
  background-color: var(--v-primary-base);
  border-bottom: solid 1px lightgray;
}

::v-deep .section-panel {
  background-color: rgb(246, 247, 248);
  border: solid 1px lightgray;
}
::v-deep .descriptionText {
  opacity: 0.7 !important;
  background-color: var("--v-appBarT-base") !important;
}

::v-deep .e-richtexteditor:not(.e-rte-toolbar-enabled) .e-rte-content {
  background-color: var("--v-appBarT-base") !important;
  border: none !important;
  color: black;
}

::v-deep .e-richtexteditor:not(.e-rte-toolbar-enabled) {
  border: none !important;
  background-color: var("--v-appBarT-base") !important;
}
</style>